import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import Image from 'components/common/Image'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'
import { A } from 'components/common/Link/Link'
import { Wrapper as Banner } from 'components/common/Banner/Banner'
import TPP from 'components/common/Icon/assets/TPP.svg'

const TPPBanner = ({
  onInfoClick,
  onCloseClick
}) =>
  <Wrapper>
    <TPPImage
      alt=""
      src={ TPP } />
    <TextBlock>
      <Title>
        Tire Protection Plan
        <InfoIcon alt="" asset="icon-info-blue-regular" onClick={ onInfoClick } />
      </Title>
      <Content>
        Your tires aren&apos;t fully protected with just a factory warranty.
        <PreventLink prevent handler={ onInfoClick }>Protect your investment</PreventLink> and more with Pro-Tec+.
      </Content>
    </TextBlock>
    <CloseButton link onClick={ onCloseClick } >
      <Icon alt="Close TPP Banner" asset="cross" />
    </CloseButton>
  </Wrapper>

TPPBanner.propTypes = {
  onCloseClick: PropTypes.func,
  onInfoClick: PropTypes.func
}

export default TPPBanner

const Wrapper = styled(Banner)`
  display: flex;
  line-height: 0;
  margin: 5px 0 15px;
  background: ${Theme.colors.light_blue};
  ${Mixin.responsive('padding', '10px 15px 5px', '20px 20px 20px 10px')}
  ${Media.mobileNarrow`
    padding: 20px 20px 20px 10px;
  `}
`

const TPPImage = styled(Image)`
  display: block;
  height: 70px;
  width: 70px;
  min-width: unset;
  ${Media.mobileNarrow`
    height: 50px;
    width: 40px;
  `}
`

const TextBlock = styled.div`
  margin-left: 15px;
  ${Mixin.responsive('padding-right', '30px', '10px')}
  ${Media.mobileNarrow`
    margin-left: 8px;
  `}
`

const Title = styled.h1`
  ${Mixin.font.GothamBold(15)}
  margin-bottom: 5px;
  text-transform: uppercase;
  ${Media.mobile`
    font-size: 14px;
  `}
  ${Media.mobileNarrow`
    font-size: 14px;
  `}
`

const Content = styled.p`
  margin: 8px 0;
  line-height: 16px;
  font-size: 13px;
  min-width: 0;
`

const InfoIcon = styled(Icon)`
  margin-left: 5px;
  margin-top: -3px;
  width: 17px;
  height: 17px;
  cursor: pointer;
`

const CloseButton = styled(Button)`
  position: absolute;

  && {
    padding: 0;
    line-height: 12px;
  }

  ${Mixin.responsive('top', '23px', '10px')}
  ${Mixin.responsive('right', '20px', '10px')}
`

const PreventLink = styled(A)`
  font-size: 13px;
  margin-left: 2px;
`
